import Model from './Model'

export default class ElementModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'elements'
  }
}
